class AlvornTanktopColours extends HTMLElement {
  connectedCallback() {
    this.colours = this.selectedColours;
    this.addEventListener('change', this.onChange);
    this.addEventListener('click', this.onPhotoClick);
    this.mediaSection = this.closest('.shopify-section, dialog');
    this.mediaSection?.addEventListener('variant:update', this.restorePhoto, true);
    window.addEventListener('pageshow', this.restoreLabels);
    this.restoreLabels();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
    this.removeEventListener('click', this.onPhotoClick);
    this.mediaSection?.removeEventListener('variant:update', this.restorePhoto, true);
    window.removeEventListener('pageshow', this.restoreLabels);
  }

  restoreLabels = () => requestAnimationFrame(() => {
    this.colours = this.selectedColours;
    this.updateLabels(this.colours);
  });

  get selectedColours() {
    return Array.from(this.querySelectorAll('input:checked'), input => input.value);
  }

  updateLabels(colours) {
    this.querySelectorAll('fieldset').forEach((fieldset, index) => {
      fieldset.querySelector('.variant-option__selected-value').textContent = colours[index];
    });
  }

  selectPhoto(gallery = this.mediaSection?.querySelector('media-gallery')) {
    const slideshow = gallery?.querySelector('slideshow-component');
    const slides = Array.from(slideshow?.querySelectorAll('slideshow-slide') ?? []);
    const index = slides.findIndex(slide => slide.querySelector('[data-media-id]')?.dataset.mediaId === this.mediaId);
    if (index < 0) return;
    if (gallery.isConnected) slideshow.select?.(index, undefined, { animate: false });
  }

  restorePhoto = (event) => {
    // Bundle variants share one gallery; keep the selected shirt photo during refresh.
    if (this.mediaId) event.detail.data.html?.querySelector('media-gallery')?.remove();
  };

  onPhotoClick = ({ target }) => {
    if (!(target instanceof HTMLInputElement) || !target.checked) return;
    this.mediaId = target.dataset.mediaId;
    this.selectPhoto();
  };

  onChange = ({ target }) => {
    if (!(target instanceof HTMLInputElement)) return;
    const colours = this.selectedColours;
    const order = ['Siyah', 'Beyaz', 'Kahverengi'];
    if (colours.length !== 3 || colours.some(colour => !order.includes(colour))) return;
    const combination = [...colours].sort((a, b) => order.indexOf(a) - order.indexOf(b)).join(' + ');
    const nativeGroup = this.nextElementSibling?.querySelector('[data-alvorn-bundle-combination]');
    const nativeInput = Array.from(nativeGroup?.querySelectorAll('input[type="radio"]') ?? []).find(input => input.value === combination);
    const status = this.querySelector('[role="status"]');
    if (!nativeInput || nativeInput.disabled) {
      this.querySelectorAll('input').forEach(input => { input.checked = input.value === this.colours[Number(input.dataset.shirt)]; });
      this.updateLabels(this.colours);
      status.textContent = status.dataset.unavailableMessage;
      return;
    }
    status.textContent = '';
    this.colours = colours;
    this.updateLabels(colours);
    this.mediaId = target.dataset.mediaId;
    this.selectPhoto();
    if (nativeInput.checked) return;
    nativeInput.checked = true;
    nativeInput.dispatchEvent(new Event('change', { bubbles: true }));
  };
}

if (!customElements.get('alvorn-tanktop-colours')) {
  customElements.define('alvorn-tanktop-colours', AlvornTanktopColours);
}

